import { createStyles } from "@mantine/styles";

export const useStyles = createStyles(() => ({
  sideBarContainer: {
    width: "240px",
    height: "100vh",
    backgroundColor: "#000",
    position: "fixed",
    display: "flex",
    flexDirection: "column",
  },
  iconbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 170,
    marginTop: 56,
    marginLeft: 0,
  },
  link: {
    textDecoration: "none",
    color: "white",
    display: "flex",
    alignItems: "center",

    // Mantine v6 NavLink renders the label/icon as child elements with their
    // own color rules, which would otherwise win over the parent `color`
    // declaration above. Target them explicitly so the cascade is order-safe.
    "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
      color: "#FFFFFF",
    },

    // :hover doubled for the same specificity reason as &[data-active][data-active]
    // below — beats Mantine's internal hover background.
    "&:hover:hover": {
      backgroundColor: "#757575",
      color: "#FFFFFF",
      borderRadius: "10px",
      "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
        color: "#FFFFFF",
      },
    },
    // Selector doubled — same target as `&[data-active]` but specificity
    // (0,3,1) beats Mantine's internal `.mantine-NavLink-root[data-active]`
    // rule (0,2,1), so the muted-gray-blue active background wins the cascade
    // regardless of which stylesheet loads first. Without the doubling, Vite 8's
    // CSS bundling order made Mantine's default light-blue active background
    // win, rendering the active tab as near-white.
    "&[data-active][data-active]": {
      borderRadius: "10px",
      color: "#FFFFFF",
      backgroundColor: "#7D8CA3",
      "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
        color: "#FFFFFF",
      },
    },
  },
  scrollArea: {
    flex: 1,
    margin: "0 20px",
  },
  footer: {
    margin: "40px 20px",
    borderTop: "1px solid #FFFFFF",
  },
}));
